module.exports = __webpack_public_path__ + "img/SVG5_IncomeSavings.21e262c9.svg";